import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { RequestEntity } from 'types';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import { AssignImg } from 'components/AssignImg/AssignImg';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import style from './Categories.module.scss';

const Categories: React.FC = () => {
	const { setIDsSelectedCategories, categories, searchStringForCategories, IDsSelectedCategories } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const filteredCategories = useMemo(() => {
		return searchStringForCategories
			? categories.filter((el) => el.name?.toLowerCase().includes(searchStringForCategories.toLowerCase()))
			: categories;
	}, [searchStringForCategories, categories]);

	const handleChange = (isChecked: boolean, categoryID: string) => {
		if (isChecked) {
			const copyIDsSelectedCategories = { ...IDsSelectedCategories };
			copyIDsSelectedCategories[categoryID] = true;
			setIDsSelectedCategories(copyIDsSelectedCategories, true);
		} else {
			const copyIDsSelectedCategories = { ...IDsSelectedCategories };
			delete copyIDsSelectedCategories[categoryID];
			setIDsSelectedCategories(copyIDsSelectedCategories, true);
		}
	};

	return (
		<div className={style.container} data-test="Categories">
			{filteredCategories.map((el) => {
				const isChecked = el.id in IDsSelectedCategories;
				const isHasAssignedDishes = el.hasAssignedDishes;
				const itemClasses = classNames(style.item, {
					[style.assign]: isHasAssignedDishes,
					[style.isChecked]: isChecked,
				});

				return (
					<div className={itemClasses} key={el.id + 'mainDisplayCategoriesTab'}>
						<div className={style.imageWrapper}>
							<ImgUploaderByEntityId
								resource={RequestEntity.Categories}
								entityID={el.filePath ? el.id : ''}
								photoSize="Small"
								loaderSize="small"
								noImageIdIcon="menu"
							/>
							{isHasAssignedDishes ? <AssignImg name="assignedDishLabel" /> : null}
						</div>
						<div className={style.name}>
							<Checkbox
								className={style.checkbox}
								onChange={(e) => handleChange(e.target.checked, el.id)}
								checked={isChecked}
							/>
							<Text translationKey={el.name} withTooltip={true} />
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Categories;

// import React, { useCallback, useContext, useMemo } from 'react'; // TODO add memoization
// import {
// 	IFirmwareAssignmentContext,
// 	FirmwareAssignmentContext,
// } from '../../../../firmwareAssignmentContext/firmwareAssignmentState/firmwareAssignmentContext';
// import AssignImg from '../AssignImg/AssignImg';
// import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
// import { Checkbox } from 'antd';
// import TooltipForText from 'components/Tooltips/TooltipForText';
// import classNames from 'classnames';
// import style from './Customers.module.scss';
// import { IDataGetCustomersForAssignFirmwareAndApp } from 'context/interfaces';
//
// const Customers: React.FC = () => {
// 	const { setIDsSelectedCustomers, allCustomers, IDsSelectedCustomers } =
// 		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);
//
// 	const handleChange = useCallback((isChecked: boolean, customerID: string) => {
// 		if (isChecked) {
// 			const copyIDsSelectedCustomers = { ...IDsSelectedCustomers };
// 			copyIDsSelectedCustomers[customerID] = false;
// 			setIDsSelectedCustomers(copyIDsSelectedCustomers, true);
// 		} else {
// 			const copyIDsSelectedCustomers = { ...IDsSelectedCustomers };
// 			delete copyIDsSelectedCustomers[customerID];
// 			setIDsSelectedCustomers(copyIDsSelectedCustomers, true);
// 		}
// 	}, []);
//
// 	return (
// 		<div className={style.container}>
// 			{allCustomers.map((el) => {
// 				const isChecked = el.id in IDsSelectedCustomers;
// 				const isHaveFirmware = el.hasFirmwares;
// 				const itemClasses = classNames(style.item, {
// 					[style.assign]: isHaveFirmware,
// 					[style.isChecked]: isChecked,
// 				});
//
// 				// eslint-disable-next-line react-hooks/rules-of-hooks
// 				const elCopy = useMemo(() => el, []);
//
// 				return (
// 					<Comp
// 						key={el.id}
// 						isChecked={isChecked}
// 						el={elCopy}
// 						isHaveFirmware={isHaveFirmware}
// 						onChange={handleChange}
// 					/>
// 				);
// 			})}
// 		</div>
// 	);
// };
//
// export default Customers;
//
// const Comp: React.FC<{
// 	el: IDataGetCustomersForAssignFirmwareAndApp;
// 	isHaveFirmware: boolean;
// 	isChecked: boolean;
// 	onChange: (flag: boolean, id: string) => void;
// }> = React.memo(({ el, isChecked, onChange, isHaveFirmware }) => {
// 	const itemClasses = classNames(style.item, {
// 		[style.assign]: isHaveFirmware,
// 		[style.isChecked]: isChecked,
// 	});
//
// 	const a = useCallback((e: any) => {
// 		onChange(e.target.checked, el.id);
// 	}, []);
//
// 	return (
// 		<div className={itemClasses} key={el.id + 'mainDisplayCustomersTab'}>
// 			<div className={style.imageWrapper}>
// 				<ImgUploaderByEntityId
// 					requestEntity="Customers"
// 					entityID={el.filePath ? el.id : ''}
// 					photoSize="Small"
// 					loaderSize="small"
// 					isFullWidth={true}
// 					noImageIdIcon="customerDefaultAvatar"
// 				/>
// 				{isHaveFirmware ? <AssignImg /> : null}
// 			</div>
// 			<div className={style.name}>
// 				<Checkbox className={style.checkbox} onChange={a} checked={isChecked} />
// 				<div className={style.divWithTooltip}>
// 					<TooltipForText>{el.name}</TooltipForText>
// 				</div>
// 			</div>
// 		</div>
// 	);
// });
